import { c as _c } from "react/compiler-runtime";
// Строки раздела «Мои покупки» (макет «Профиль»):
// — позиция: белая r20, фото 100×133 r16 (отступ 8) с сердцем, название 16/20
//   w600, «вариант …» 12 #2E2E2E, цена 12, статус 12 (строки через 4) (зелёный «Доставлен» / красный
//   «Возвращен» + дата), серая кнопка «В корзину» или «Похожие» h32 r8,
//   меню «…»: Поддержка / Вернуть товар (или Открыть спор);
// — заказ (группировка): сумма 16, дата 12, миниатюры 50×66 r4 с размером.
import { useState } from "react";
import { Link } from "react-router";
import type { BuyerPurchase, Product } from "@/api";
import { DotsHorizontalIcon, FavoriteHeartIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useFormatPrice } from "@/lib/use-format-price";
import { cn } from "@/lib/utils";
import { useWishlist } from "@/store";
import { fmtShortDate, ProductTile, Thumb } from "./return-parts";
const STATUS: Record<BuyerPurchase["status"], {
  label: string;
  className: string;
}> = {
  delivered: {
    label: "Доставлен",
    className: "text-[#32D47D]"
  },
  return_pending: {
    label: "Возврат оформлен",
    className: "text-[#FF8D28]"
  },
  returned: {
    label: "Возвращен",
    className: "text-[#E1574F]"
  }
};
export function PurchaseRow(t0) {
  const $ = _c(68);
  const {
    item,
    product,
    onToCart,
    onReturn,
    onDispute,
    onSupport,
    busy
  } = t0;
  const fmt = useFormatPrice();
  let t1;
  if ($[0] !== item.productId) {
    t1 = s => s.ids.includes(item.productId);
    $[0] = item.productId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const liked = useWishlist(t1);
  const toggleProduct = useWishlist(_temp);
  const setProductLikedOnServer = useWishlist(_temp2);
  const [menu, setMenu] = useState(false);
  const status = STATUS[item.status];
  const onSale = Boolean(product && product.status === "published" && product.stock > 0);
  const canReturn = item.returnableQuantity > 0 && item.status !== "returned";
  const t2 = `/product/${item.productId}`;
  let t3;
  if ($[2] !== item.photo) {
    t3 = <ProductTile src={item.photo} />;
    $[2] = item.photo;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <Link to={t2} className="shrink-0 rounded-[16px] outline-none focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40">{t3}</Link>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = liked ? "\u0423\u0431\u0440\u0430\u0442\u044C \u0438\u0437 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E" : "\u0412 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435";
  let t6;
  if ($[7] !== item.productId || $[8] !== setProductLikedOnServer || $[9] !== toggleProduct) {
    t6 = () => {
      const next = toggleProduct(item.productId);
      setProductLikedOnServer(item.productId, next);
    };
    $[7] = item.productId;
    $[8] = setProductLikedOnServer;
    $[9] = toggleProduct;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== liked) {
    t7 = <FavoriteHeartIcon active={liked} />;
    $[11] = liked;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== liked || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <button type="button" aria-label={t5} aria-pressed={liked} onClick={t6} className="absolute top-2 left-[76px] grid size-8 place-items-center rounded-full outline-none focus-visible:ring-2 focus-visible:ring-ds-focus">{t7}</button>;
    $[13] = liked;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = `/product/${item.productId}`;
  let t10;
  if ($[18] !== item.name || $[19] !== t9) {
    t10 = <Link to={t9} className="truncate text-[16px] leading-5 font-semibold tracking-[-0.31px] text-[#1F1F1F] outline-none hover:text-[#FA5C2E]">{item.name}</Link>;
    $[18] = item.name;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <PopoverTrigger asChild={true}><button type="button" aria-label={"\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F"} className="-mt-0.5 grid h-6 w-7 shrink-0 place-items-center rounded-[6px] text-[#333] outline-none hover:bg-[#F8F8F8] focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40"><DotsHorizontalIcon size={24} /></button></PopoverTrigger>;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== onSupport) {
    t12 = <MenuItem onClick={() => {
      setMenu(false);
      onSupport();
    }}>Поддержка</MenuItem>;
    $[22] = onSupport;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== canReturn || $[25] !== item.canDispute || $[26] !== onDispute || $[27] !== onReturn) {
    t13 = item.canDispute ? <MenuItem danger={true} onClick={() => {
      setMenu(false);
      onDispute();
    }}>Открыть спор</MenuItem> : canReturn ? <MenuItem danger={true} onClick={() => {
      setMenu(false);
      onReturn();
    }}>Вернуть товар</MenuItem> : null;
    $[24] = canReturn;
    $[25] = item.canDispute;
    $[26] = onDispute;
    $[27] = onReturn;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <PopoverContent align="end" sideOffset={6} className="w-auto min-w-[128px] rounded-[12px] border-0 p-[3px] shadow-[0_4px_16px_rgba(0,0,0,0.08)]">{t12}{t13}</PopoverContent>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== menu || $[33] !== t14) {
    t15 = <Popover open={menu} onOpenChange={setMenu}>{t11}{t14}</Popover>;
    $[32] = menu;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t10 || $[36] !== t15) {
    t16 = <div className="flex items-start justify-between gap-3">{t10}{t15}</div>;
    $[35] = t10;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== item.size || $[39] !== item.variant) {
    t17 = item.variant ? <p className="mt-1 text-[12px] leading-4 text-[#2E2E2E]">вариант {item.size || item.variant}</p> : null;
    $[38] = item.size;
    $[39] = item.variant;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== fmt || $[42] !== item.unitPrice) {
    t18 = fmt(item.unitPrice);
    $[41] = fmt;
    $[42] = item.unitPrice;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t18) {
    t19 = <p className="mt-1 text-[12px] leading-4 text-[#1F1F1F]">{t18}</p>;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== status.className) {
    t20 = cn("mt-1 text-[12px] leading-4", status.className);
    $[46] = status.className;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  const t21 = item.statusAt ? `  ${fmtShortDate(item.statusAt)}` : "";
  let t22;
  if ($[48] !== status.label || $[49] !== t20 || $[50] !== t21) {
    t22 = <p className={t20}>{status.label}{t21}</p>;
    $[48] = status.label;
    $[49] = t20;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== busy || $[53] !== item.name || $[54] !== onSale || $[55] !== onToCart || $[56] !== product) {
    t23 = <div className="mt-auto pt-2">{onSale ? <Button variant="gray" size="sm" disabled={busy} onClick={onToCart}>В корзину</Button> : <Button variant="gray" size="sm" asChild={true}><Link to={product?.categoryId ? `/catalog?categoryId=${encodeURIComponent(product.categoryId)}` : `/catalog?search=${encodeURIComponent(item.name)}`}>Похожие</Link></Button>}</div>;
    $[52] = busy;
    $[53] = item.name;
    $[54] = onSale;
    $[55] = onToCart;
    $[56] = product;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t16 || $[59] !== t17 || $[60] !== t19 || $[61] !== t22 || $[62] !== t23) {
    t24 = <div className="flex min-w-0 flex-1 flex-col">{t16}{t17}{t19}{t22}{t23}</div>;
    $[58] = t16;
    $[59] = t17;
    $[60] = t19;
    $[61] = t22;
    $[62] = t23;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  let t25;
  if ($[64] !== t24 || $[65] !== t4 || $[66] !== t8) {
    t25 = <article className="relative flex gap-3 rounded-[20px] bg-white p-2">{t4}{t8}{t24}</article>;
    $[64] = t24;
    $[65] = t4;
    $[66] = t8;
    $[67] = t25;
  } else {
    t25 = $[67];
  }
  return t25;
}
function _temp2(s_1) {
  return s_1.setProductLikedOnServer;
}
function _temp(s_0) {
  return s_0.toggleProduct;
}
function MenuItem(t0) {
  const $ = _c(6);
  const {
    children,
    onClick,
    danger
  } = t0;
  const t1 = danger ? "text-[#E1574F]" : "text-[#1F1F1F]";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex h-[39px] w-full items-center rounded-[8px] px-3 text-left text-[14px] whitespace-nowrap outline-none transition-colors hover:bg-[#F5F5F5] focus-visible:bg-[#F5F5F5]", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== onClick || $[4] !== t2) {
    t3 = <button type="button" onClick={onClick} className={t2}>{children}</button>;
    $[2] = children;
    $[3] = onClick;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export type PurchaseOrderGroup = {
  orderId: string;
  orderCreatedAt: string;
  total: number;
  items: BuyerPurchase[];
};
export function PurchaseOrderRow(t0) {
  const $ = _c(20);
  const {
    group
  } = t0;
  const fmt = useFormatPrice();
  const t1 = `/profile/purchases/${encodeURIComponent(group.orderId)}`;
  let t2;
  if ($[0] !== fmt || $[1] !== group.total) {
    t2 = fmt(group.total);
    $[0] = fmt;
    $[1] = group.total;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <p className="text-[16px] leading-5 font-medium whitespace-nowrap text-[#1F1F1F]">{t2}</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== group.orderCreatedAt) {
    t4 = fmtShortDate(group.orderCreatedAt);
    $[5] = group.orderCreatedAt;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <p className="mt-1.5 text-[12px] leading-4 text-[#1F1F1F]/48">{t4}</p>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="w-[62px] shrink-0 self-start pt-1.5">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== group.items) {
    t7 = group.items.flatMap(_temp3);
    $[12] = group.items;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div className="flex min-w-0 flex-1 gap-1 overflow-hidden">{t7}</div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t6 || $[18] !== t8) {
    t9 = <Link to={t1} className="flex items-center gap-4 rounded-[20px] bg-white px-3 py-2 outline-none transition-shadow hover:shadow-[0_2px_12px_rgba(0,0,0,0.05)] focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40">{t6}{t8}</Link>;
    $[16] = t1;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
function _temp3(it) {
  return Array.from({
    length: Math.max(1, it.quantity)
  }, (_, i) => <Thumb key={`${it.orderLineId}-${i}`} src={it.photo} label={it.size || it.variant} />);
}